import React from 'react'
import Reveal, { MaskLines } from './Reveal'

/**
 * Editorial section header: a small indexed label sits left, the display
 * heading runs wide. Deliberately not centred — centred headings over card
 * grids are the template look we're avoiding.
 */
const SectionIntro = ({ index, label, lines, description, tone = 'dark', className = '' }) => {
  const light = tone === 'light'
  return (
    <div className={`grid gap-8 md:grid-cols-[10rem_1fr] md:gap-12 ${className}`}>
      <Reveal className="flex items-baseline gap-4 pt-2">
        {index && (
          <span className={`index-num ${light ? 'text-paper-100/40' : ''}`}>{index}</span>
        )}
        <span className={`label ${light ? 'label-dark' : ''}`}>{label}</span>
      </Reveal>

      <div>
        <MaskLines
          lines={lines}
          className={`display-2 ${light ? 'text-paper-100' : ''}`}
        />
        {description && (
          <Reveal delay={220}>
            <p
              className={`mt-8 max-w-xl text-lg leading-relaxed ${
                light ? 'text-paper-100/55' : 'text-ink-500'
              }`}
            >
              {description}
            </p>
          </Reveal>
        )}
      </div>
    </div>
  )
}

export default SectionIntro
